type SourceQuestionState = {
  awaitingUserInput?: { toolCallId: string } | null;
  updatedAt: number;
  activeResponseWorkflowId?: string;
};

/** Gate admission precedes tool-result persistence; completion must refresh it too. */
export function getRealtimeVoicePendingQuestionRevision(
  thread: SourceQuestionState
): string | undefined {
  if (!thread.awaitingUserInput) return undefined;
  return JSON.stringify([
    thread.awaitingUserInput.toolCallId,
    thread.updatedAt,
    thread.activeResponseWorkflowId ?? null,
  ]);
}
